import { getLocalContext } from '@thoughtspot/blink-context';
import { ColumnType, } from '@thoughtspot/ts-chart-sdk';
import _ from 'lodash';
import React from 'react';
export var CustomChartAppActions;
(function (CustomChartAppActions) {
    CustomChartAppActions[CustomChartAppActions["SET_VISUAL_PROP_DEFINITION"] = 0] = "SET_VISUAL_PROP_DEFINITION";
    CustomChartAppActions[CustomChartAppActions["SET_CUSTOM_CHART_EDITOR_DEFINITION"] = 1] = "SET_CUSTOM_CHART_EDITOR_DEFINITION";
    CustomChartAppActions[CustomChartAppActions["SET_VALIDATE_CUSTOM_CHART_CONFIG_CB_FN"] = 2] = "SET_VALIDATE_CUSTOM_CHART_CONFIG_CB_FN";
    CustomChartAppActions[CustomChartAppActions["SET_VALIDATE_CUSTOM_VISUAL_PROPS_CB_FN"] = 3] = "SET_VALIDATE_CUSTOM_VISUAL_PROPS_CB_FN";
    CustomChartAppActions[CustomChartAppActions["SET_ALLOWED_CONFIGURATIONS"] = 4] = "SET_ALLOWED_CONFIGURATIONS";
    CustomChartAppActions[CustomChartAppActions["SET_CHART_CONFIG_PARAMETERS"] = 5] = "SET_CHART_CONFIG_PARAMETERS";
    CustomChartAppActions[CustomChartAppActions["SET_CHART_CONFIG_QUERIES"] = 6] = "SET_CHART_CONFIG_QUERIES";
    CustomChartAppActions[CustomChartAppActions["SET_GET_COLUMN_DATA_CB_FN"] = 7] = "SET_GET_COLUMN_DATA_CB_FN";
    CustomChartAppActions[CustomChartAppActions["SET_DISPATCH_CUSTOM_CHART_MIXPANEL_EVENT_CB_FN"] = 8] = "SET_DISPATCH_CUSTOM_CHART_MIXPANEL_EVENT_CB_FN";
    CustomChartAppActions[CustomChartAppActions["SET_PERSISTED_VISUAL_PROP_KEYS"] = 9] = "SET_PERSISTED_VISUAL_PROP_KEYS";
    CustomChartAppActions[CustomChartAppActions["SET_ALL_CONFIGS"] = 10] = "SET_ALL_CONFIGS";
})(CustomChartAppActions || (CustomChartAppActions = {}));
const DEFAULT_ERROR_MESSAGE_FN = () => {
    throw new Error('This method is not implemented/overridden');
};
const defaultCustomChartState = {
    visualPropEditorDefinition: {
        elements: [],
        columnsVizPropDefinition: [
            {
                type: ColumnType.MEASURE,
                columnSettingsDefinition: {
                    'column-id': { elements: [] },
                },
            },
        ],
    },
    chartConfigEditorDefinition: [],
    validateCustomChartConfig: DEFAULT_ERROR_MESSAGE_FN,
    validateCustomVisualProps: DEFAULT_ERROR_MESSAGE_FN,
    dispatchCustomChartMixpanelEvent: DEFAULT_ERROR_MESSAGE_FN,
    allowedConfigurations: {
        allowColumnNumberFormatting: false,
        allowColumnConditionalFormatting: false,
        allowGradientColoring: false,
        allowMeasureNamesAndValues: false,
    },
    persistedVisualPropKeys: undefined,
    globalPersistedKeyVisualProp: undefined,
    chartConfigParameters: {
        measureNameValueColumns: {
            enableMeasureNameColumn: false,
            enableMeasureValueColumn: false,
            measureNameColumnAlias: 'Measure Name',
            measureValueColumnAlias: 'Measure Value',
        },
    },
    chartConfigQueries: [],
};
export const reducer = (state, action) => {
    switch (action.type) {
        case CustomChartAppActions.SET_VISUAL_PROP_DEFINITION:
            return {
                ...state,
                visualPropEditorDefinition: action.visualPropEditorDefinition,
            };
        case CustomChartAppActions.SET_CUSTOM_CHART_EDITOR_DEFINITION:
            return {
                ...state,
                chartConfigEditorDefinition: action.chartConfigEditorDefinition,
            };
        case CustomChartAppActions.SET_VALIDATE_CUSTOM_CHART_CONFIG_CB_FN:
            return {
                ...state,
                validateCustomChartConfig: action.validateCustomChartConfig,
            };
        case CustomChartAppActions.SET_VALIDATE_CUSTOM_VISUAL_PROPS_CB_FN:
            return {
                ...state,
                validateCustomVisualProps: action.validateCustomVisualProps,
            };
        case CustomChartAppActions.SET_ALLOWED_CONFIGURATIONS:
            return {
                ...state,
                allowedConfigurations: {
                    ...defaultCustomChartState.allowedConfigurations,
                    ...action.allowedConfigurations,
                },
            };
        case CustomChartAppActions.SET_PERSISTED_VISUAL_PROP_KEYS: {
            let currentGlobalPersistedKeyVisualProp = state.globalPersistedKeyVisualProp
                ? state.globalPersistedKeyVisualProp
                : defaultCustomChartState.globalPersistedKeyVisualProp;
            const newPersistedKeys = action.persistedVisualPropKeys
                ? action.persistedVisualPropKeys
                : defaultCustomChartState.persistedVisualPropKeys;
            currentGlobalPersistedKeyVisualProp = _.uniq([
                ...(currentGlobalPersistedKeyVisualProp || []),
                ...(newPersistedKeys || []),
            ]);
            return {
                ...state,
                persistedVisualPropKeys: newPersistedKeys,
                globalPersistedKeyVisualProp: currentGlobalPersistedKeyVisualProp,
            };
        }
        case CustomChartAppActions.SET_CHART_CONFIG_PARAMETERS:
            return {
                ...state,
                chartConfigParameters: _.merge({}, defaultCustomChartState.chartConfigParameters, action?.chartConfigParameters),
            };
        case CustomChartAppActions.SET_CHART_CONFIG_QUERIES:
            return {
                ...state,
                chartConfigQueries: action.chartConfigQueries,
            };
        case CustomChartAppActions.SET_GET_COLUMN_DATA_CB_FN:
            return {
                ...state,
                getColumnData: action.getColumnData,
            };
        case CustomChartAppActions.SET_DISPATCH_CUSTOM_CHART_MIXPANEL_EVENT_CB_FN:
            return {
                ...state,
                dispatchCustomChartMixpanelEvent: action.dispatchCustomChartMixpanelEvent,
            };
        case CustomChartAppActions.SET_ALL_CONFIGS: {
            let currentGlobalPersistedKeyVisualProp = state.globalPersistedKeyVisualProp
                ? state.globalPersistedKeyVisualProp
                : defaultCustomChartState.globalPersistedKeyVisualProp;
            const newPersistedKeys = action.allConfigs.persistedVisualPropKeys
                ? action.allConfigs.persistedVisualPropKeys
                : defaultCustomChartState.persistedVisualPropKeys;
            currentGlobalPersistedKeyVisualProp = _.uniq([
                ...(currentGlobalPersistedKeyVisualProp || []),
                ...(newPersistedKeys || []),
            ]);
            return {
                ...state,
                ...action.allConfigs,
                visualPropEditorDefinition: action.allConfigs.visualPropEditorDefinition,
                chartConfigEditorDefinition: action.allConfigs.chartConfigEditorDefinition,
                validateCustomChartConfig: action.allConfigs.validateCustomChartConfig,
                validateCustomVisualProps: action.allConfigs.validateCustomVisualProps,
                dispatchCustomChartMixpanelEvent: action.allConfigs.dispatchCustomChartMixpanelEvent,
                allowedConfigurations: {
                    ...defaultCustomChartState.allowedConfigurations,
                    ...action.allConfigs.allowedConfigurations,
                },
                persistedVisualPropKeys: newPersistedKeys,
                globalPersistedKeyVisualProp: currentGlobalPersistedKeyVisualProp,
                chartConfigParameters: _.merge({}, defaultCustomChartState.chartConfigParameters, action.allConfigs.chartConfigParameters),
                getColumnData: action.allConfigs.getColumnData,
            };
        }
        default:
            return state;
    }
};
const getDispatcherFunctions = (dispatch) => {
    const setVisualPropEditorDefinition = (visualPropEditorDefinition) => {
        dispatch({
            type: CustomChartAppActions.SET_VISUAL_PROP_DEFINITION,
            visualPropEditorDefinition,
        });
    };
    const setChartConfigEditorDefiniton = (chartConfigEditorDefinition) => {
        dispatch({
            type: CustomChartAppActions.SET_CUSTOM_CHART_EDITOR_DEFINITION,
            chartConfigEditorDefinition,
        });
    };
    const setValidateChartConfigCB = (validateCustomChartConfig) => {
        dispatch({
            type: CustomChartAppActions.SET_VALIDATE_CUSTOM_CHART_CONFIG_CB_FN,
            validateCustomChartConfig,
        });
    };
    const setValidateCustomVisualPropsCB = (validateCustomVisualProps) => {
        dispatch({
            type: CustomChartAppActions.SET_VALIDATE_CUSTOM_VISUAL_PROPS_CB_FN,
            validateCustomVisualProps,
        });
    };
    const setAllowedConfigurations = (allowedConfigurations) => {
        dispatch({
            type: CustomChartAppActions.SET_ALLOWED_CONFIGURATIONS,
            allowedConfigurations,
        });
    };
    const setPersistedVisualPropKeys = (persistedVisualPropKeys) => {
        dispatch({
            type: CustomChartAppActions.SET_PERSISTED_VISUAL_PROP_KEYS,
            persistedVisualPropKeys,
        });
    };
    const setChartConfigParameters = (chartConfigParameters) => {
        dispatch({
            type: CustomChartAppActions.SET_CHART_CONFIG_PARAMETERS,
            chartConfigParameters,
        });
    };
    const setChartConfigQueries = (chartConfigQueries) => {
        dispatch({
            type: CustomChartAppActions.SET_CHART_CONFIG_QUERIES,
            chartConfigQueries,
        });
    };
    const setGetColumnDataCB = (getColumnData) => {
        dispatch({
            type: CustomChartAppActions.SET_GET_COLUMN_DATA_CB_FN,
            getColumnData,
        });
    };
    const setDispatchCustomChartMixpanelEventCB = (dispatchCustomChartMixpanelEvent) => {
        dispatch({
            type: CustomChartAppActions.SET_DISPATCH_CUSTOM_CHART_MIXPANEL_EVENT_CB_FN,
            dispatchCustomChartMixpanelEvent,
        });
    };
    const setAllConfigs = (allConfigs) => {
        dispatch({
            type: CustomChartAppActions.SET_ALL_CONFIGS,
            allConfigs,
        });
    };
    return {
        setVisualPropEditorDefinition,
        setChartConfigEditorDefiniton,
        setValidateChartConfigCB,
        setValidateCustomVisualPropsCB,
        setAllowedConfigurations,
        setPersistedVisualPropKeys,
        setChartConfigParameters,
        setChartConfigQueries,
        setGetColumnDataCB,
        setDispatchCustomChartMixpanelEventCB,
        setAllConfigs,
    };
};
let contextCache = null;
const initializeContext = () => {
    if (!contextCache) {
        contextCache = getLocalContext('custom-chart-context', reducer, defaultCustomChartState, getDispatcherFunctions);
    }
    return contextCache;
};
export const CustomChartContextProvider = ({ children, value }) => {
    const { ContextProvider } = initializeContext();
    if (value) {
        return React.createElement(ContextProvider, { value, children });
    }
    return React.createElement(ContextProvider, { children });
};
export const getCustomChartContext = () => {
    const { getState } = initializeContext();
    return getState();
};
export const setCustomChartContext = () => {
    const { getStateSetterMethods } = initializeContext();
    return getStateSetterMethods();
};
//# sourceMappingURL=custom-chart-app-context.js.map